<template>
  <b-container>
    <b-row>
      <slot></slot>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'SectionRowContainer'
};
</script>

<style lang="scss" scoped>
div.container {
  padding-top: 30px;
  padding-bottom: 30px;

  @media (max-width: $mediaMdWidth) {
    padding-top: 20px;
    padding-bottom: 20px;
  }
}
</style>